export class LocalUserModel {
  public email: string;
  public password: string;
}
